(function(window, questionSetViewFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.QuestionSetView = questionSetViewFactory(
      window.$,
      namespace.templates,
      namespace.BubbleView,
      namespace.localizationStrings,
      namespace.log,
      namespace.events,
      namespace.rationaleActionType,
      namespace.QuestionView,
      namespace.deviceInfo);
})(this, function($,
                  templates,
                  BubbleView,
                  localizationStrings,
                  log,
                  events,
                  rationaleActionType,
                  QuestionView,
                  deviceInfo) {
   'use strict';

   var SUBMITTING_GLYPH_DATA_URL = 'data:image/gif;base64,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';

   var CONTAINER_CLASS = '.question-set-container';
   var PREV_CONTROL_CLASS = '.previous-button';
   var NEXT_CONTROL_CLASS = '.next-button';
   var SUBMIT_CONTROL_CLASS = '.submit-button';
   var CONTINUE_CONTROL_CLASS = '.continue-button';
   var QUESTION_COUNT_CLASS = '.question-count';
   var QUESTION_CLASS = '.question-text';
   var ANSWERS_CLASS = '.question-answers';
   var FEEDBACK_CLASS = '.question-feedback';

   /**
    * @memberof TSC
    * @class QuestionSetView
    * @param {Object} $container -- Container to add question set view.
    * @param {TSC.QuestionSet} questionSet -- Question Set model for view.
    * @param {Boolean} displayOverlay -- Display overlay.
    * @param {Boolean} mediaIsImage -- Media is an image.
    * @param {Boolean} showQuestionSetResults -- Show user results for question set.
    * @classdesc View for Question sets.
    */
   var QuestionSetView = function($container, questionSet, displayOverlay, mediaIsImage, showQuestionSetResults) {
      var _currentQuestionIndex = 0;
      var _$container = $container;
      var _questionSetTemplate;
      var _questionCountTemplate;
      var _startTimeForQuestion = 0;
      var _endTimeForQuestion = 0;
      var _currentQuestionView = null;
      var _$questionSetContainer = null;
      var _$questionTextContainer = null;
      var _$answersContainer = null;
      var _$feedbackContainer = null;
      var _$questionCountContainer = null;
      var _$prevControl = null;
      var _$nextControl = null;
      var _$continueControl = null;
      var _$submitControl = null;
      var _superView = BubbleView.create(CONTAINER_CLASS);

      if (templates && templates.question_set_template) {
         _questionSetTemplate = templates.question_set_template;
      } else {
         log.logException('questionSetView: Question Set Template not found.');
      }

      if (templates && templates.question_count_template) {
         _questionCountTemplate = templates.question_count_template;
      } else {
         log.logException('questionSetView: Question Count Template not found.');
      }

      var isOnFirstQuestion = function() {
         return _currentQuestionIndex === 0;
      };

      var isOnLastQuestion = function() {
         return _currentQuestionIndex === questionSet.questions.length - 1;
      };

      var showView = function() {
         _$questionSetContainer.removeClass('minimized');
         _superView.showView();
      };

      var hideView = function() {
         _$questionSetContainer.addClass('minimized');
         _superView.hideView();
      };

      var startTrackingQuestionTime = function() {
         _startTimeForQuestion = new Date().getTime();
      };

      var recordDurationOnQuestion = function() {
         _endTimeForQuestion = new Date().getTime();

         var timeBetween = _endTimeForQuestion - _startTimeForQuestion;
         questionSet.questions[_currentQuestionIndex].attemptDuration += timeBetween;
      };

      var storeUserResponse = function() {
         var userResponse = _currentQuestionView.getUserResponse();

         if (userResponse !== undefined && userResponse !== '') {
            questionSet.questions[_currentQuestionIndex].userResponse = userResponse;
         }
      };

      var saveQuestionUserInput = function() {
         if (showQuestionSetResults) {
            return;
         }

         storeUserResponse();
         recordDurationOnQuestion();
      };

      var lockResponses = function() {
         if (questionSet.usesRationale) {
            questionSet.questions[_currentQuestionIndex].responseLocked = true;
         } else {
            questionSet.questions.forEach(function(question) {
               question.responseLocked = true;
            });
         }
      };

      var getFeedbackInfoForCurrentQuestion = function() {
         var actionType = rationaleActionType.CONTINUE;
         var feedback;

         if (questionSet.questions[_currentQuestionIndex].isGraded) {
            var feedbackReason = questionSet.questions[_currentQuestionIndex].isResponseCorrect ? 'correct' : 'incorrect';
            feedback = questionSet.questions[_currentQuestionIndex].getFeedbackForReason(feedbackReason);

            if (feedback !== null) {
               if (feedback.location !== undefined) {
                  actionType = rationaleActionType.LOCATION;
               } else if (feedback.jumpToTime !== undefined) {
                  actionType = rationaleActionType.JUMP_TO_TIME;
               }
            }
         }

         return {feedback: feedback, actionType: actionType};
      };

      var executeContinueAction = function() {
         if (isOnLastQuestion()) {
            $container.trigger(events.Quizzing.CloseQuestionSetView);
         } else {
            displayNextQuestion();
         }
      };

      var executeRationaleAction = function() {
         var feedbackInfo;

         if (questionSet.questions[_currentQuestionIndex].feedbackActionExecuted) {
            feedbackInfo = {actionType: rationaleActionType.CONTINUE};
         } else {
            feedbackInfo = getFeedbackInfoForCurrentQuestion();
            questionSet.questions[_currentQuestionIndex].feedbackActionExecuted = true;
         }

         switch (feedbackInfo.actionType) {
            case rationaleActionType.CONTINUE:
               executeContinueAction();
               break;
            case rationaleActionType.LOCATION:
               $container.trigger(events.Quizzing.RationaleActionLocation, {location: feedbackInfo.feedback.location});
               executeContinueAction();
               break;
            case rationaleActionType.JUMP_TO_TIME:
               if (questionSet.startTime !== feedbackInfo.feedback.jumpToTime) {
                  $container.trigger(events.Quizzing.RationaleActionJumpToTime, {jumpToTime: feedbackInfo.feedback.jumpToTime});
               } else {
                  executeContinueAction();
               }
               break;
         }
      };

      var displayNextQuestion = function() {
         saveQuestionUserInput();

         _currentQuestionIndex++;
         displayQuestion();
      };

      var onPreviousQuestion = function(e) {
         e.preventDefault();

         saveQuestionUserInput();

         _currentQuestionIndex--;
         displayQuestion();
      };

      var onNextQuestion = function(e) {
         e.preventDefault();

         displayNextQuestion();
      };

      var onContinue = function(e) {
         e.preventDefault();

         if (questionSet.usesRationale && !showQuestionSetResults) {
            executeRationaleAction();
         } else {
            $container.trigger(events.Quizzing.CloseQuestionSetView);
         }
      };

      var onSubmit = function(e) {
         e.preventDefault();

         _$submitControl.attr('disabled', 'disabled');

         saveQuestionUserInput();
         lockResponses();

         $container.trigger(events.Quizzing.SubmitQuestionSet);
      };

      //This is a fix for iPhones whipping users back to the top of the page if there is a focused input.
      var onIphoneTouchstart = function() {
         _$questionSetContainer.find('.fill-in-the-blank-input').blur();
      };

      var getControlsConfig = function() {
         var currentQuestion = questionSet.questions[_currentQuestionIndex];
         var onFirstQuestion = isOnFirstQuestion();
         var onLastQuestion = isOnLastQuestion();
         var hasOneQuestion = onFirstQuestion && onLastQuestion;

         var controlsConfig = {
            showSubmitNav: false,
            showContinueNav: false,
            showPrevNav: false,
            showNextNav: false,
            prevDisabled: false,
            nextDisabled: false
         };

         if (questionSet.usesRationale && !showQuestionSetResults) {
            if (currentQuestion.responseLocked) {
               if (currentQuestion.feedbackActionExecuted && !onLastQuestion) {
                  controlsConfig.showNextNav = true;
               } else {
                  controlsConfig.showContinueNav = true;
               }
            } else {
               controlsConfig.showSubmitNav = true;
            }
            controlsConfig.showPrevNav = !hasOneQuestion && !onFirstQuestion;
         } else {
            controlsConfig.showSubmitNav = !showQuestionSetResults && onLastQuestion;
            controlsConfig.showContinueNav = showQuestionSetResults && onLastQuestion && !mediaIsImage;
            controlsConfig.showPrevNav = !hasOneQuestion;
            controlsConfig.showNextNav = !hasOneQuestion && !controlsConfig.showSubmitNav && !controlsConfig.showContinueNav;
            controlsConfig.prevDisabled = _currentQuestionIndex === 0;
            controlsConfig.nextDisabled = onLastQuestion;
         }

         return controlsConfig;
      };

      var updateControls = function() {
         var controlsConfig = getControlsConfig();

         _$prevControl.css('display', 'none');
         _$nextControl.css('display', 'none');
         _$submitControl.css('display', 'none');
         _$continueControl.css('display', 'none');

         if (controlsConfig.showPrevNav) {
            _$prevControl.css('display', 'inline');

            if (controlsConfig.prevDisabled) {
               _$prevControl.attr('disabled', 'disabled');
            } else {
               _$prevControl.removeAttr('disabled');
            }
         }

         if (controlsConfig.showNextNav) {
            _$nextControl.css('display', 'inline');

            if (controlsConfig.nextDisabled) {
               _$nextControl.attr('disabled', 'disabled');
            } else {
               _$nextControl.removeAttr('disabled');
            }
         }

         if (controlsConfig.showSubmitNav) {
            _$submitControl.removeAttr('disabled');
            _$submitControl.css('display', 'inline');
         }

         if (controlsConfig.showContinueNav) {
            _$continueControl.css('display', 'inline');
         }
      };

      var displayQuestion = function() {
         var showResults = showQuestionSetResults;
         if (questionSet.usesRationale && questionSet.questions[_currentQuestionIndex].responseLocked) {
            showResults = true;
         }
         if (_currentQuestionView !== null) {
            _currentQuestionView.destroy();
         }
         _currentQuestionView = QuestionView.create(_$questionTextContainer, _$feedbackContainer, _$answersContainer, questionSet.questions[_currentQuestionIndex], showResults);
         updateQuestionCount();
         updateControls();
         startTrackingQuestionTime();
      };

      var updateQuestionCount = function() {
         var questionCountContext = {
            currentQuestionNumber: _currentQuestionIndex + 1,
            totalQuestions: questionSet.questions.length,
            prepositionText: localizationStrings.getQuestionCountPreposition()
         };
         var questionCountMarkup = _questionCountTemplate(questionCountContext);
         _$questionCountContainer.html(questionCountMarkup);
      };

      var showFeedbackForCurrentQuestion = function() {
         displayQuestion();
         updateControls();
      };

      var createView = function() {
         var context = {
            previousButtonName: localizationStrings.strings.txtPrev,
            nextButtonName: localizationStrings.strings.txtNext,
            submitButtonName: localizationStrings.strings.txtSubmit,
            continueButtonName: localizationStrings.strings.txtContinue,
            submittingImg: SUBMITTING_GLYPH_DATA_URL,
            submittingImgAltText: localizationStrings.strings.txtSubmittingAnswers
         };

         var questionSetViewMarkup = _questionSetTemplate(context);

         if (displayOverlay) {
            questionSetViewMarkup += _superView.getOverlayMarkup();
         }

         _$container.append(questionSetViewMarkup);

         _$questionSetContainer = _$container.find(CONTAINER_CLASS);
         _$questionTextContainer = _$container.find(QUESTION_CLASS);
         _$answersContainer = _$container.find(ANSWERS_CLASS);
         _$feedbackContainer = _$container.find(FEEDBACK_CLASS);
         _$questionCountContainer = _$container.find(QUESTION_COUNT_CLASS);
         _$prevControl = _$container.find(PREV_CONTROL_CLASS);
         _$nextControl = _$container.find(NEXT_CONTROL_CLASS);
         _$continueControl = _$container.find(CONTINUE_CONTROL_CLASS);
         _$submitControl = _$container.find(SUBMIT_CONTROL_CLASS);
      };

      var removeEvents = function() {
         _$prevControl.off('click', onPreviousQuestion);
         _$nextControl.off('click', onNextQuestion);
         _$submitControl.off('click', onSubmit);
         _$continueControl.off('click', onContinue);

         if (deviceInfo.isIPhoneOrIPod()) {
            _$questionSetContainer.off('touchstart', onIphoneTouchstart);
         }
      };

      var setupEvents = function() {
         _$prevControl.on('click', onPreviousQuestion);
         _$nextControl.on('click', onNextQuestion);
         _$submitControl.on('click', onSubmit);
         _$continueControl.on('click', onContinue);

         if (deviceInfo.isIPhoneOrIPod()) {
            _$questionSetContainer.on('touchstart', onIphoneTouchstart);
         }
      };

      var checkQuestionSetProgress = function() {
         if (showQuestionSetResults) {
            return;
         }
         for (var i = 0; i < questionSet.questions.length; i++) {
            if (!questionSet.questions[i].responseLocked) {
               _currentQuestionIndex = i;
               break;
            }
         }
      };

      var removeView = function(completeCallback, destroyOverlay) {
         removeEvents();
         _currentQuestionView.destroy();
         _superView.removeView(completeCallback, destroyOverlay);
      };

      createView();
      checkQuestionSetProgress();
      setupEvents();
      displayQuestion();

      return {
         showView: showView,
         hideView: hideView,
         removeView: removeView,
         showFeedbackForCurrentQuestion: showFeedbackForCurrentQuestion,
         updateViewPosition: _superView.updateViewPosition,
         setBottomOffset: _superView.setBottomOffset,
         pointAt: _superView.pointAt
      };
   };

   return {
      create: QuestionSetView
   };
});
